import { useTranslation } from 'react-i18next'

import { CompactAlert } from '~/components/common/CompactAlert'

type Props = {
  /** 検知した売買逆転の件数 (同一受渡日・同一エリア・同一コマの組の数)。 */
  count: number
}

/**
 * 時間前入札の売買逆転 (価格交差) 検知バナー (intraday-bidding.md AC-BIN-045 / AC-BIN-046)。
 * 入札追加タブと CSV 取込の Step2 で同じ文言・同じ見た目にするための共通部品。
 * 検知件数が 0 の時は出さない。 検知しても提出・取込は止めない (意図的な両建てがありうるため)。
 * 「売買逆転のみ表示」は持たない (Alert に入力部品を置かない)。
 */
export const IntradayInversionAlert = ({
  count,
}: Props): React.ReactElement | null => {
  const { t } = useTranslation()
  if (count === 0) return null
  return (
    <CompactAlert
      description={t('page:biddingIntraday.alert.inversionBody')}
      status="warning"
      title={t('page:biddingIntraday.alert.inversionTitle', { count })}
    />
  )
}
